import type { LoginResponse, PermisoEnum, RoleEnum, SuscripcionDTO, UsuarioDTO } from '../model/kartera-api-model'

export interface SessionUser extends UsuarioDTO {
    agenteId: number | null
    suscripcion: SuscripcionDTO | null
    rol: RoleEnum[]
    permisos: PermisoEnum[]
}

const toArray = (value: unknown): string[] => {
    if (!value) return []
    if (Array.isArray(value)) return value
    if (typeof value === 'string') return [value]
    if (typeof value === 'object') return Object.values(value)
    return []
}

export const mapLoginUser = (body: LoginResponse | null | undefined): SessionUser | null => {
    if (!body?.usuario) return null
    return {
        ...body.usuario,
        agenteId: body.agenteId,
        suscripcion: body.suscripcion,
        rol: toArray(body.role),
        permisos: toArray(body.permisos),
    }
}
